import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import {
    Container,
    Box,
    Typography,
    CircularProgress,
    Button,
    Stack,
    Grid,
    Paper,
} from '@mui/material';
import { ConfigContext, useForm, http } from '../m34n-ui/src/lib';

const onLoad = async ({ values }) => {
    const order = await http.get({}, `${values.config.uri.base}/order/${values._id}`);

    return {
        ...values,
        ...order,
        loading: false,
    };
};

export default function OrderDetail() {
    const { orderId } = useParams();
    const { config } = useContext(ConfigContext);

    const { state } = useForm({
        debug: true,
        initialState: {
            config,
            _id: orderId,
            registrationType: '',
            role: '',
            groupMembers: '',
            firstName: '',
            lastName: '',
            email: '',
            confirmEmail: '',
            phoneCountry: '',
            phone: '',
            birthDate: '',
            recipientInfo: '',
            churchInfo: '',
            otherChurchInfo: '',
            expectations: '',
            previousAttendance: [],
            vocation: '',
            otherVocation: '',
            receiveUpdates: false,
            shippingAddress: '',
            shippingCity: '',
            shippingState: '',
            shippingPostalCode: '',
            shippingCountry: '',
            selectedShippingOption: {},
            productId: '',
            printJob: {
                line_items: []
            },
            tenantId: '',
            appId: '',
            createdAt: null,
            updatedAt: null,
            deletedAt: null,
            deletedBy: '',
            deleted: false,
            loading: true,
            totalPrice: 0
        },
        onLoad
    });

    const handleDelete = async () => {
        await http.delete({}, `${config.uri.base}/order/${state.values._id}`);
        window.location.href = '/orders';
    };

    const renderTile = (label, value) => (
        <Grid item xs={12} sm={6}>
            <Paper elevation={2} sx={{ padding: '16px', margin: '8px' }}>
                <Typography variant="subtitle1"><strong>{label}:</strong></Typography>
                <Typography variant="body1">{value}</Typography>
            </Paper>
        </Grid>
    );

    return (
        <Container>
            {state.values.loading ? (
                <CircularProgress />
            ) : (
                    <>
                        <Typography variant="h5" sx={{ marginTop: '20px' }}>Order Details</Typography>
                        <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                            {renderTile("Registration Type", state.values.registrationType)}
                            {/* {renderTile("Role", state.values.role)}
                        {renderTile("Group Members", state.values.groupMembers)} */}
                            {renderTile("First Name", state.values.firstName)}
                            {renderTile("Last Name", state.values.lastName)}
                            {renderTile("Email", state.values.email)}
                            {renderTile("Confirm Email", state.values.confirmEmail)}
                            {renderTile("Phone Country", state.values.phoneCountry)}
                            {renderTile("Phone", state.values.phone)}
                            {/* {renderTile("Birth Date", new Date(state.values.birthDate).toLocaleDateString())}
                        {renderTile("Recipient Info", state.values.recipientInfo)}
                        {renderTile("Church Info", state.values.churchInfo)}
                        {renderTile("Expectations", state.values.expectations)}
                        {renderTile("Vocation", state.values.vocation)} */}
                            {renderTile("Receive Updates", state.values.receiveUpdates ? 'Yes' : 'No')}
                            {renderTile("Shipping Address", state.values.shippingAddress)}
                            {renderTile("Shipping City", state.values.shippingCity)}
                            {renderTile("Shipping State", state.values.shippingState)}
                            {renderTile("Shipping Postal Code", state.values.shippingPostalCode)}
                            {renderTile("Shipping Country", state.values.shippingCountry)}
                        </Grid>

                        {/* Additional Members Section */}
                        <Typography variant="h6" sx={{ marginTop: '40px' }}>Additional Members</Typography>
                        <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                            {state.values.additionalMembers?.length > 0 ? (
                                state.values.additionalMembers.map((member, index) => (
                                    <React.Fragment key={index}>
                                        {renderTile("First Name", member.firstName)}
                                        {renderTile("Last Name", member.lastName)}
                                        {renderTile("Email", member.email)}
                                    </React.Fragment>
                                ))
                            ) : (
                                    <Typography variant="body1">No additional members.</Typography>
                                )}
                        </Grid>

                        <Typography variant="h6" sx={{ marginTop: '40px' }}>Additional Participants with  no book</Typography>
                        <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                            {state.values.additionalParticipantsNoBook ? (
                                renderTile("Additional Participants", state.values.additionalParticipantsNoBook)
                            ) : (
                                    <Typography variant="body1">No additional participants.</Typography>
                                )}
                        </Grid>


                        <Typography variant="h6" sx={{ marginTop: '40px' }}>Shipping Option</Typography>
                        <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                            {renderTile("Carrier Service Name", state.values.selectedShippingOption.carrier_service_name)}
                            {renderTile("Level", state.values.selectedShippingOption.level)}
                            {renderTile("Cost Excl Tax", state.values.selectedShippingOption.cost_excl_tax)}
                            {renderTile("Currency", state.values.selectedShippingOption.currency)}
                            {renderTile("Min Dispatch Date", new Date(state.values.selectedShippingOption.min_dispatch_date).toLocaleDateString())}
                            {renderTile("Max Dispatch Date", new Date(state.values.selectedShippingOption.max_dispatch_date).toLocaleDateString())}
                            {renderTile("Min Delivery Date", new Date(state.values.selectedShippingOption.min_delivery_date).toLocaleDateString())}
                            {renderTile("Max Delivery Date", new Date(state.values.selectedShippingOption.max_delivery_date).toLocaleDateString())}
                        </Grid>

                        <Typography variant="h6" sx={{ marginTop: '40px' }}>Print Job</Typography>
                        <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                            {renderTile("Contact Email", state.values.printJob.contact_email)}
                            {renderTile("Shipping Level", state.values.printJob.shipping_level)}
                            {renderTile("Production Delay", state.values.printJob.production_delay)}
                            {state.values.printJob.line_items?.map((item, index) => (
                                <React.Fragment key={index}>
                                    {renderTile("Title", item.title)}
                                    {renderTile("Quantity", item.quantity)}
                                    {renderTile("Cover URL", <a href={item.printable_normalization.cover.source_url} target="_blank" rel="noopener noreferrer">Cover PDF</a>)}
                                    {renderTile("Interior URL", <a href={item.printable_normalization.interior.source_url} target="_blank" rel="noopener noreferrer">Interior PDF</a>)}
                                </React.Fragment>
                            ))}
                            {renderTile("Total Price", state.values.totalPrice || 0)}
                        </Grid>

                        <Typography variant="h6" sx={{ marginTop: '40px' }}>Read-Only Fields</Typography>
                        <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                            {renderTile("ID", state.values._id)}
                            {renderTile("Created At", new Date(state.values.createdAt).toLocaleDateString())}
                            {renderTile("Updated At", state.values.updatedAt ? new Date(state.values.updatedAt).toLocaleDateString() : 'N/A')}
                            {renderTile("Deleted", state.values.deleted ? 'Yes' : 'No')}
                            {renderTile("Tenant ID", state.values.tenantId)}
                            {renderTile("App ID", state.values.appId)}
                        </Grid>

                        <Box sx={{ marginTop: '20px' }}>
                            <Button variant="contained" color="error" onClick={handleDelete}>
                                Delete Order
                        </Button>
                        </Box>
                    </>
                )}
        </Container>
    );
}
